import React, { useEffect, useMemo } from 'react'
import Page from './Page'
import MetaWrapper from '@components/Meta/MetaWrapper'
import { useWholesaleProductsQuery } from '@graphql/queries/__generated__/wholesale.generated'
import useGlobalLoader from '../../../hooks/useGlobalLoader'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useTranslation } from 'react-i18next'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { setLoading } = useGlobalLoader()
  const meQueryResult = useMeQuery({ fetchPolicy: 'cache-first', nextFetchPolicy: 'cache-first' })
  const { data, loading } = useWholesaleProductsQuery({
    variables: { first: 10 },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  useEffect(() => {
    setLoading(loading && !data)
  }, [loading, data])

  const products = useMemo(() => data?.wholesaleProducts.edges.map(edge => edge.node) || [], [data])

  return (
    <MetaWrapper titleDetails={t('metaTitle.wholesaleProducts', 'Wholesale Products')}>
      <Page products={products} user={meQueryResult.data?.me} />
    </MetaWrapper>
  )
}

export default View
